// Блокировка ввода после нуля таймера хода (см. utils/gameState/turn/turnInputLock).
//
//  - lockedTurnKey — ключ хода, для которого ввод игрока заблокирован: его
//    время вышло, а сервер ход еще не закрыл. Действует, только пока совпадает
//    с текущим ходом (selectIsTurnInputLocked) — снимать его при смене хода не
//    нужно;
//  - releasedTurnKey — ключ хода, блокировку которого снял предохранитель
//    (закрытие от сервера так и не пришло): для него блокировка заново не
//    ставится;
//  - isAwaitingServerTimestamp — этот клиент сам сменил ход или этап (свое
//    завершение, ход бота, исполненный здесь), а метку начала нового отрезка
//    сервер еще не прислал: turnEndTimestamp в состоянии — от ПРОШЛОГО отрезка,
//    и считать по нему «время вышло» нельзя.
const initialState = {
  lockedTurnKey: null,
  releasedTurnKey: null,
  isAwaitingServerTimestamp: false,
};

// Клиентские завершения: метку времени в них сервер не принимает и присылает
// свою отдельным SET_TURN_END_TIMESTAMP (см. RELAY_ACTION в server/index.js)
const LOCAL_TURN_TRANSITION_TYPES = ['COMPLETE_PHASE', 'START_NEXT_PHASE', 'SET_WAR_PHASE_STAGE'];

const turnInputLockReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LOCK_TURN_INPUT':
      if (state.lockedTurnKey === action.payload.turnKey || state.releasedTurnKey === action.payload.turnKey) {
        return state;
      }
      return {...state, lockedTurnKey: action.payload.turnKey};
    case 'RELEASE_TURN_INPUT':
      if (state.lockedTurnKey !== action.payload.turnKey) {
        return state;
      }
      return {...state, lockedTurnKey: null, releasedTurnKey: action.payload.turnKey};
    case 'SET_TURN_END_TIMESTAMP':
    case 'LOAD_STATE':
      return state.isAwaitingServerTimestamp ? {...state, isAwaitingServerTimestamp: false} : state;
    default:
      if (!action._fromServer && LOCAL_TURN_TRANSITION_TYPES.includes(action.type) && !state.isAwaitingServerTimestamp) {
        return {...state, isAwaitingServerTimestamp: true};
      }
      return state;
  }
};

export default turnInputLockReducer;
